import type {
  IProductionAssignmentRepository,
  ProductionAssignmentListQuery,
} from '@domain/data-contracts/production-assignment-repository.interface';
import type { ProductionAssignment } from '@domain/models/production-assignment.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class ProductionAssignmentsService {
  public constructor(private readonly repo: IProductionAssignmentRepository) {}

  public search(query: ProductionAssignmentListQuery): Promise<PagedResult<ProductionAssignment>> {
    return this.repo.search(query);
  }

  public listByOrderId(orderId: string): Promise<readonly ProductionAssignment[]> {
    return this.repo.listByOrderId(orderId);
  }

  public markStepComplete(assignmentId: string): Promise<ProductionAssignment> {
    return this.repo.markStepComplete(assignmentId);
  }
}
